module.exports = __webpack_public_path__ + "static/media/orange-employee.9ce73d71.svg";